export default (app) => {
    //自定义指令-触底重新加载
    app.directive('loadMore', {
        beforeMount(el, binding) {
            console.log('触发了自定义指令2--');
            console.info(binding)
            console.info(el)

            // 获取element，定义scroll
            let select_dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
            select_dom.addEventListener('scroll', function () {
                console.log("触发了自定义指令3-绑定的scroll事件")
                let height = this.scrollHeight - this.scrollTop <= this.clientHeight
                if (height) {
                    binding.value()
                }
            })
        }
    })
}
